"use strict";

import angular from "angular";

export class AccountingNewsService {
    news = [];
    loading = false;
    constructor() {}
    get() {
        return this.news;
    }
    set(news) {
        this.news = news;
    }
}

angular.module("nucont.shared")
    .service("AccountingNewsService", [AccountingNewsService]);
